export default __webpack_public_path__ + "788662f496c3c3df5729aa14d3d49556.png";